module.exports = __webpack_public_path__ + "static/media/c2-class@2x.4b5b5183.png";